import SockJS from 'sockjs-client';
import Stomp, { Frame } from 'stompjs';
import {
  updateOddsfromWS,
  updateMultiOddsfromWS,
  updateSecondaryMatchOdds,
  updateMultiSecondaryMatchOdds,
  getSapTokenFromToken,
  updatePremiumMarkes,
  updateFancyMarkets,
  updateBookMakerMarkets,
  updateMultiBookMakerMarkets,
  updateMultiFancyMarkets,
  getHouseIdFromToken,
  getParentIdFromToken,
} from '../store';
import store from '../store/store';
import { getBaseUrl } from '../api-services/environment-url/environment-url';
import {
  setBetFairWSConnection,
  setDreamWSConnection,
  setPushNotifWSConnection,
  setSportsRadarWSConnection,
  triggerFetchMarkets,
  triggerFetchOrders,
  updateBinaryMarkets,
  updateDisabledMarkets,
  updateSuspendedMarkets,
} from '../store/exchangeSports/exchangeSportsActions';
import moment from 'moment';
import { NotificationType } from '../models/NotificationTypes';
import {
  triggerMultiFetchMarkets,
  triggerMultiFetchOrders,
  updateMultiDisabledMarkets,
  updateMultiSuspendedMarkets,
} from '../store/multimarket/multimarketAction';
import {
  triggerFetchBalance,
  triggerFetchNotifications,
} from '../store/common/commonActions';
import { Jwt_token } from '../util/stringUtil';
import { getFieldFromToken } from '../store/auth/authActions';

let pushNotClient: Stomp.Client = null;
let pnLastMsgTime = null;
let stompClient: Stomp.Client = null;
let bfLastMsgTime = null;
let binaryStompClient: Stomp.Client = null;
let sportRadarClient: Stomp.Client = null;
let dreamClient: Stomp.Client = null;

let refreshBetFairInterval: NodeJS.Timeout | undefined;
let refreshSportsRadarInterval: NodeJS.Timeout | undefined;
let refreshDreamInterval: NodeJS.Timeout | undefined;
let refreshPushNotInterval: NodeJS.Timeout | undefined;
// Push notifications Subscription
let wsPushNotSubscriptions = {};

// Match Odds Subscriptions
let wsSubscriptions = {};
let eventHierarchyMap: Map<string, string> = new Map();

let wsSpSubscriptions = {};

// Bookmaker & Fancy Subscriptions
let wsSecMarketSubscritions = {};
let wsFancyMarketSubscritions = {};

// Secondary Match Odds Subscriptions
let wsSecMatchOddsSubscritions = {};

// Binary Subscriptions
let wsSecBinarySubscrition;

// Check WS connection.
export const isPushNotificationConnected = () =>
  pushNotClient && pushNotClient.connected;
export const isConnected = () => stompClient && stompClient.connected;
export const isBinaryConnected = () =>
  binaryStompClient && binaryStompClient.connected;
export const isSportRadarConnected = () =>
  sportRadarClient && sportRadarClient.connected;
export const isDreamWsConnected = () => dreamClient && dreamClient.connected;

export const connectToPushNotification = () => {
  if (pushNotClient == null) {
    const baseUrl = getBaseUrl(
      process.env.REACT_APP_NODE_ENV,
      'REACT_APP_WEBSOCKET_URL_PUSH_NOTIFICATIONS'
    );
    const socket = new SockJS(baseUrl);
    pushNotClient = Stomp.over(socket);
    pushNotClient.heartbeat.outgoing = 5000;
    pushNotClient.connect(
      {},
      function (frame) {
        console.log('PN Connected: ' + frame + ' time ' + moment.now());
        store.dispatch(setPushNotifWSConnection(true))
        clearInterval(refreshPushNotInterval);
        refreshPushNotInterval = undefined;
        subscribeWsForNotifications(
          getFieldFromToken(Jwt_token.HOUSE_ID),
          getFieldFromToken(Jwt_token.ACCOUNT_ID)
        );
      },
      function (error: Frame | string) {
        store.dispatch(setPushNotifWSConnection(false))
        disConnectToPushNotificationWS();
        console.log('pn ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshPushNotInterval === 'undefined') {
          refreshPushNotInterval && clearInterval(refreshPushNotInterval);
          refreshPushNotInterval = setInterval(() => {
            connectToPushNotification();
          }, 30 * 1000);
        }
      }
    );
    pnLastMsgTime = moment.now();
  }
};

export const disConnectToPushNotificationWS = () => {
  if (pushNotClient != null) {
    for (const houseId of Object.keys(wsPushNotSubscriptions)) {
      wsPushNotSubscriptions[houseId].unsubscribe();
      console.log('pn unsubscribed ' + houseId);
      delete wsPushNotSubscriptions[houseId];
    }

    wsPushNotSubscriptions = {};

    if (store.getState().exchangeSports.pushNotifWSConnection) {
      pushNotClient.disconnect(() =>
        console.log('PN Disconnected - time ' + moment.now())
      );
    }
    pushNotClient = null;
  }
};

export const connectToDreamWS = (dreamWsUrl: any) => {
  if (dreamClient === null) {
    // Bookmaker & Fancy
    const dreamSocket = new SockJS(dreamWsUrl);
    dreamClient = Stomp.over(dreamSocket);
    dreamClient.debug = null;
    dreamClient.heartbeat.outgoing = 1000;
    dreamClient.connect(
      { token: `Bearer ${getSapTokenFromToken()}` },
      function (frame) {
        console.log('DR Connected: ' + frame);
        store.dispatch(setDreamWSConnection(true));
        clearInterval(refreshDreamInterval);
        refreshDreamInterval = undefined;
      },
      function (error: Frame | string) {
        store.dispatch(setDreamWSConnection(false));
        disConnectToDreamWS();
        console.log('dream ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshDreamInterval === 'undefined') {
          refreshDreamInterval && clearInterval(refreshDreamInterval);

          refreshDreamInterval = setInterval(() => {
            connectToDreamWS(dreamWsUrl);
          }, 30 * 1000);
        }
      }
    );
  }
}

// Exchange Events.
export const connectToWS = (baseUrlsPayload: any) => {
  connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  connectToDreamWS(baseUrlsPayload?.bookMakerAndFancyBaseUrl);
  connectToSRWS(baseUrlsPayload?.premiumBaseUrl);
};

const connectToBFWS = (baseUrl: string) => {
  if (stompClient == null) {
    // Match odds
    const socket = new SockJS(baseUrl);
    stompClient = Stomp.over(socket);
    stompClient.debug = null;
    stompClient.heartbeat.outgoing = 5000;
    stompClient.connect(
      { token: `Bearer ${getSapTokenFromToken()}` },
      function (frame) {
        console.log('BF Connected: ' + frame + ' time ' + moment.now());
        store.dispatch(setBetFairWSConnection(true))
        clearInterval(refreshBetFairInterval);
        refreshBetFairInterval = undefined;
      },
      function (error: Frame | string) {
        store.dispatch(setBetFairWSConnection(false))
        disConnectToBFWS();
        console.log('bf ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshBetFairInterval === 'undefined') {
          refreshBetFairInterval && clearInterval(refreshBetFairInterval);
          refreshBetFairInterval = setInterval(() => {
            connectToBFWS(baseUrl);
          }, 30 * 1000);
        }
      }
    );
    bfLastMsgTime = moment.now();
  }
};

const disConnectToBFWS = () => {
  if (stompClient != null) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      wsSubscriptions[wsEvent].unsubscribe();
      console.log('bf unsubscribed ' + wsEvent);
      delete wsSubscriptions[wsEvent];
    }

    for (const wsEvent of Object.keys(wsSecMatchOddsSubscritions)) {
      wsSecMatchOddsSubscritions[wsEvent].unsubscribe();
      console.log('bf unsubscribed ' + wsEvent);
      delete wsSecMatchOddsSubscritions[wsEvent];
    }

    wsSubscriptions = {};
    wsSecMatchOddsSubscritions = {};

    if (store.getState().exchangeSports.betFairWSConnected) {
      stompClient.disconnect(() =>
        console.log('BF Disconnected - time ' + moment.now())
      );
    }
    stompClient = null;
  }
};

export const connectToSRWS = (spBaseUrl: any) => {
  if (sportRadarClient === null) {
    // Sportradar
    const spSocket = new SockJS(spBaseUrl);
    sportRadarClient = Stomp.over(spSocket);
    sportRadarClient.debug = null;
    sportRadarClient.heartbeat.outgoing = 5000;
    sportRadarClient.connect(
      { token: `Bearer ${getSapTokenFromToken()}` },
      function (frame) {
        console.log('SR Connected: ' + frame);
        store.dispatch(setSportsRadarWSConnection(true));
        clearInterval(refreshSportsRadarInterval);
        refreshSportsRadarInterval = undefined;
      },
      function (error: Frame | string) {
        store.dispatch(setSportsRadarWSConnection(false));
        disConnectToSRWS();
        console.log('SR ws_error: ' + error + ' time ' + moment.now());
        if (typeof refreshSportsRadarInterval === 'undefined') {
          refreshSportsRadarInterval && clearInterval(refreshSportsRadarInterval);
          refreshSportsRadarInterval = setInterval(() => {
            connectToSRWS(spBaseUrl);
          }, 30 * 1000);
        }
      }
    );
  }
}

const disConnectToDreamWS = () => {
  if (dreamClient != null) {
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      wsSecMarketSubscritions[wsEvent].unsubscribe();
      console.log('dream unsubscribed ' + wsEvent);
      delete wsSecMarketSubscritions[wsEvent];
    }
    wsSecMarketSubscritions = {};
    for (const wsEvent of Object.keys(wsFancyMarketSubscritions)) {
      wsFancyMarketSubscritions[wsEvent].unsubscribe();
      console.log('dream unsubscribed ' + wsEvent);
      delete wsFancyMarketSubscritions[wsEvent];
    }
    wsFancyMarketSubscritions = {};
    dreamClient.disconnect(() =>
      console.log('Dream Disconnected - time ' + moment.now())
    );
    dreamClient = null;
  }
};

const disConnectToSRWS = () => {
  if (sportRadarClient != null) {
    for (const wsEvent of Object.keys(wsSpSubscriptions)) {
      wsSpSubscriptions[wsEvent].unsubscribe();
      console.log('sr unsubscribed ' + wsEvent);
      delete wsSpSubscriptions[wsEvent];
    }
    wsSpSubscriptions = {};
    sportRadarClient.disconnect(() =>
      console.log('SR Disconnected - time ' + moment.now())
    );
    sportRadarClient = null;
  }
};

export const subscribeSportRadarEventOdds = (
  url: string,
  dreamEventId: string,
  eventId: string
) => {
  const topicUrl = `${url}/${eventId}`;

  if (sportRadarClient !== null && sportRadarClient.connected) {
    if (wsSpSubscriptions[`sp-${eventId}`] === undefined) {
      wsSpSubscriptions[`sp-${eventId}`] = sportRadarClient.subscribe(
        topicUrl,
        function (message) {
          const msgObj = JSON.parse(message.body);
          if (eventId) {
            const payload = {
              eventId: dreamEventId,
              body: msgObj,
            };
            store.dispatch(updatePremiumMarkes(payload));
          }
        }
      );
    }
  } else {
    setTimeout(
      () => subscribeSportRadarEventOdds(url, dreamEventId, eventId),
      1000
    );
  }
};

export const connectToBinaryWS = () => {
  const baseUrl = getBaseUrl(
    process.env.REACT_APP_NODE_ENV,
    'BINARY_WEBSOCKET_URL'
  );
  const socket = new SockJS(baseUrl);
  binaryStompClient = Stomp.over(socket);
  binaryStompClient.debug = null;
  binaryStompClient.heartbeat.outgoing = 10000;
  binaryStompClient.connect({}, function (frame) {
    console.log('Binary ws Connected: ' + frame);
  });
};

export const checkPNStompClientSubscriptions = () => {
  if (!(store.getState().exchangeSports.pushNotifWSConnection)) {
    connectToPushNotification();
  }
  if (moment.now() - pnLastMsgTime > 300000) {
    console.log(
      'PN last message is > 300000' + (moment.now() - pnLastMsgTime) + 'ms'
    );
    disConnectToPushNotificationWS();
    // Getting balance when websocket is geeting disconnected
    store.dispatch(triggerFetchBalance(moment.now()));
    connectToPushNotification();
  }
};

export const checkStompClientSubscriptions = (baseUrlsPayload: any) => {
  if (!(store.getState().exchangeSports.betFairWSConnected)) {
    console.log('BetFair client is null or not connected');
    connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  }
  if (!(store.getState().exchangeSports.dreamWSConnected)) {
    console.log('Dream client is null or not connected');
    connectToDreamWS(baseUrlsPayload?.bookMakerAndFancyBaseUrl);
  }
  if (!(store.getState().exchangeSports.sportsRadarWSConnected)) {
    console.log('SR client is null or not connected');
    connectToSRWS(baseUrlsPayload?.premiumBaseUrl);
  }
};

export const subscribeWsForEventOdds = (
  urlTopic: string,
  sportId: string,
  competitionId: string,
  eventId: string,
  marketId: string,
  providerId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    if (wsSubscriptions[eventId] === undefined) {
      eventHierarchyMap.set(eventId, `${sportId}-${competitionId}`);
      wsSubscriptions[eventId] = stompClient.subscribe(
        `${urlTopic}/${eventId}/${marketId}`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          const msgBody = {
            eventId: msgObj.eventId,
            matchOdds: {
              marketId: msgObj.marketId,
              marketTime: msgObj.marketTime,
              marketName: msgObj.marketName,
              status: msgObj.status,
              runners: msgObj.runners,
            },
          };
          const eventId = msgObj.eventId;
          if (eventId) {
            const payload = {
              eventData: msgBody.matchOdds ? msgBody.matchOdds : 'no-data',
              sportId: eventHierarchyMap.get(eventId).split('-')[0],
              competitionId: eventHierarchyMap.get(eventId).split('-')[1],
              eventId: eventId,
              matchOddsData: msgBody.matchOdds ? msgBody.matchOdds : null,
            };

            if (payload && payload !== undefined) {
              isMultiMarket
                ? store.dispatch(updateMultiOddsfromWS(payload))
                : store.dispatch(updateOddsfromWS([payload]));
              // store.dispatch(updateBetslipfromWS(payload));
            }
          }
        }
      );
      // console.log(wsSubscriptions[eventId]);
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForEventOdds(
          urlTopic,
          sportId,
          competitionId,
          eventId,
          marketId,
          providerId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForNotifications = (
  isMultiMarket: boolean,
  houseId: string,
  sportId?: string,
  competitionId?: string,
  eventId?: string
) => {
  if (store.getState().exchangeSports.pushNotifWSConnection) {
    if (wsPushNotSubscriptions[houseId] === undefined) {
      wsPushNotSubscriptions[houseId] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            if (isMultiMarket) {
              switch (notification.notification_type) {
                case NotificationType.MARKET_SUSPENDED: {
                  store.dispatch(
                    updateMultiSuspendedMarkets(notification.data)
                  );
                  break;
                }
                case NotificationType.ORDER_LIMIT_UPDATED: {
                  store.dispatch(triggerMultiFetchMarkets(notification.data));
                  break;
                }
                case NotificationType.NOTIFICATION_UPDATED: {
                  store.dispatch(triggerFetchNotifications(notification.data));
                  break;
                }
                case NotificationType.MARKET_DISABLED: {
                  store.dispatch(updateMultiDisabledMarkets(notification.data));
                  break;
                }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            } else {
              switch (notification.notification_type) {
                case NotificationType.MARKET_SUSPENDED: {
                  if (
                    notification.data?.eventId &&
                    eventId === notification.data.eventId
                  ) {
                    store.dispatch(updateSuspendedMarkets(notification.data));
                  }
                  break;
                }
                case NotificationType.ORDER_LIMIT_UPDATED: {
                  store.dispatch(
                    triggerFetchMarkets(
                      sportId,
                      competitionId,
                      eventId,
                      notification.data
                    )
                  );
                  break;
                }
                case NotificationType.NOTIFICATION_UPDATED: {
                  store.dispatch(triggerFetchNotifications(notification.data));
                  break;
                }
                case NotificationType.MARKET_DISABLED: {
                  if (
                    notification.data?.eventId &&
                    eventId === notification.data.eventId
                  ) {
                    store.dispatch(updateDisabledMarkets(notification.data));
                  }
                  break;
                }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed to update suspend market details ', ex);
          }
        }
      );
    }
  } else {
    // TODO: is this required ?
    setTimeout(
      () =>
        subscribeWsForNotifications(
          isMultiMarket,
          houseId,
          sportId,
          competitionId,
          eventId
        ),
      1000
    );
  }
};

export const subscribeWsForNotificationsPerAdmin = (
  isMultiMarket: boolean,
  houseId: string,
  parentId: string,
  accountId: string
) => {
  if (store.getState().exchangeSports.pushNotifWSConnection) {
    if (wsPushNotSubscriptions[parentId] === undefined) {
      wsPushNotSubscriptions[parentId] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}/${parentId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            if (notification.data.accountId === accountId) {
              switch (notification.notification_type) {
                case NotificationType.BALANCE_CHANGED: {
                  store.dispatch(triggerFetchBalance(moment.now()));
                  break;
                }
                case NotificationType.ORDER_UPDATED: {
                  if (isMultiMarket) {
                    store.dispatch(
                      triggerMultiFetchOrders(notification?.data?.eventId)
                    );
                  }
                  break;
                }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed process notification ', ex);
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForNotificationsPerAdmin(
          isMultiMarket,
          houseId,
          parentId,
          accountId
        ),
      1000
    );
  }
};

export const subscribeWsForNotificationsPerAdminAllMarkets = (
  isMultiMarket: boolean,
  houseId: string,
  parentId: string,
  accountId: string,
  eventId: string
) => {
  var key = eventId ? parentId + ':' + eventId : parentId;
  if (store.getState().exchangeSports.pushNotifWSConnection) {
    if (wsPushNotSubscriptions[key] === undefined && eventId !== undefined) {
      wsPushNotSubscriptions[key] = pushNotClient.subscribe(
        `/topic/notifications/${houseId}/${parentId}`,
        function (message) {
          try {
            const notification = JSON.parse(message.body);
            if (notification.data.accountId === accountId) {
              switch (notification.notification_type) {
                case NotificationType.BALANCE_CHANGED: {
                  store.dispatch(triggerFetchBalance(moment.now()));
                  break;
                }
                case NotificationType.ORDER_UPDATED: {
                  if (!isMultiMarket) {
                    if (eventId && eventId === notification?.data?.eventId) {
                      store.dispatch(triggerFetchOrders());
                    }
                  }
                  break;
                }
                default:
                  console.log(
                    'Invalid notification type: ',
                    notification.notification_type
                  );
              }
            }
            pnLastMsgTime = moment.now();
          } catch (ex) {
            console.error('Failed process notification ', ex);
          }
        }
      );
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForNotificationsPerAdminAllMarkets(
          isMultiMarket,
          houseId,
          parentId,
          accountId,
          eventId
        ),
      1000
    );
  }
};

export const subscribeWsForSecondaryMarkets = (
  url: string,
  eventId: string,
  marketId: string,
  sportId?: string,
  competitionId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.dreamWSConnected) {
    let bmUrl = url.includes('tommy')
      ? `${url}/${eventId}/${marketId}`
      : `${url}/${eventId}`;
    if (wsSecMarketSubscritions[eventId + marketId] === undefined) {
      wsSecMarketSubscritions[eventId + marketId] = dreamClient.subscribe(
        bmUrl,
        function (message) {
          const msgObj = JSON.parse(message.body);
          const eventId = msgObj.eventId;
          const bookmakers = msgObj;
          if (eventId) {
            const secMarketsPayload = {
              eventId: eventId,
              bookmakerOddsData: bookmakers ? bookmakers : [],
              enableBookmaker: true,
            };
            isMultiMarket
              ? store.dispatch(
                  updateMultiBookMakerMarkets({
                    ...secMarketsPayload,
                    sportId,
                    competitionId,
                  })
                )
              : store.dispatch(updateBookMakerMarkets(secMarketsPayload));
          }
        }
      );
      // console.log(wsSecMarketSubscritions[eventId]);
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForSecondaryMarkets(
          url,
          eventId,
          marketId,
          sportId,
          competitionId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForFancyMarkets = (
  url: string,
  eventId: string,
  marketId?: string,
  sportId?: string,
  competitionId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.dreamWSConnected) {
    let fmUrl = `${url}/${eventId}`;
    if (wsFancyMarketSubscritions[eventId] === undefined) {
      wsFancyMarketSubscritions[eventId] = dreamClient.subscribe(
        fmUrl,
        function (message) {
          const msgObj = JSON.parse(message.body);
          if (eventId) {
            const fancyMarketsPayload = {
              eventId: eventId,
              fancyUpdateData: msgObj,
              enableBookmaker: true,
            };
            // store.dispatch(updateSecondaryMarkets(secMarketsPayload));
            isMultiMarket
              ? store.dispatch(
                  updateMultiFancyMarkets({
                    ...fancyMarketsPayload,
                    sportId,
                    competitionId,
                  })
                )
              : store.dispatch(updateFancyMarkets(fancyMarketsPayload));
          }
        }
      );
      // console.log(wsSecMarketSubscritions[eventId]);
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForFancyMarkets(
          url,
          eventId,
          marketId,
          sportId,
          competitionId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForSecondaryMatchOdds = (
  urlTopic: string,
  eventId: string,
  marketId: string,
  providerId: string,
  sportId?: string,
  competitionId?: string,
  isMultiMarket?: boolean
) => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    if (wsSecMatchOddsSubscritions[eventId + '-' + marketId] === undefined) {
      wsSecMatchOddsSubscritions[eventId + '-' + marketId] =
        stompClient.subscribe(
          `${urlTopic}/${eventId}/${marketId}`,
          function (message) {
            const msgObj = JSON.parse(message.body);
            const msgBody = {
              eventId: msgObj.eventId,
              matchOdds: {
                marketId: msgObj.marketId,
                marketTime: msgObj.marketTime,
                marketName: msgObj.marketName,
                status: msgObj.status,
                runners: msgObj.runners,
              },
            };
            const eventId = msgObj.eventId;
            if (eventId) {
              const secMatchOddsPayload = {
                eventId: eventId,
                marketId: msgBody.matchOdds?.marketId,
                matchOddsData: msgBody.matchOdds ? msgBody.matchOdds : null,
              };
              isMultiMarket
                ? store.dispatch(
                    updateMultiSecondaryMatchOdds({
                      ...secMatchOddsPayload,
                      sportId,
                      competitionId,
                    })
                  )
                : store.dispatch(updateSecondaryMatchOdds(secMatchOddsPayload));
            }
          }
        );
      // console.log(wsSecMatchOddsSubscritions[eventId + '-' + marketId]);
    }
  } else {
    setTimeout(
      () =>
        subscribeWsForSecondaryMatchOdds(
          urlTopic,
          eventId,
          marketId,
          providerId,
          sportId,
          competitionId,
          isMultiMarket
        ),
      1000
    );
  }
};

export const subscribeWsForBinaryMarkets = () => {
  if (binaryStompClient !== null && binaryStompClient.connected) {
    if (wsSecBinarySubscrition === undefined) {
      wsSecBinarySubscrition = binaryStompClient.subscribe(
        `/topic/binary_odds_update_new`,
        function (message) {
          const msgObj = JSON.parse(message.body);
          if (msgObj) {
            store.dispatch(updateBinaryMarkets(msgObj));
          }
        }
      );
    }
  } else {
    setTimeout(() => subscribeWsForBinaryMarkets(), 1000);
  }
};

export const unsubscribePNWsforEvents = (id: string) => {
  if (store.getState().exchangeSports.pushNotifWSConnection) {
    wsPushNotSubscriptions[id]?.unsubscribe();
    console.log('unsubscribed PN ' + id);
    delete wsPushNotSubscriptions[id];
  }
};

export const unsubscribeAllWsforEvents = () => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      wsSubscriptions[wsEvent].unsubscribe();
      delete wsSubscriptions[wsEvent];
      // console.log(wsSubscriptions);
    }

    for (const wsEvent of Object.keys(wsSecMatchOddsSubscritions)) {
      wsSecMatchOddsSubscritions[wsEvent].unsubscribe();
      delete wsSecMatchOddsSubscritions[wsEvent];
    }

    wsSubscriptions = {};
    wsSecMatchOddsSubscritions = {};
  }

  if (store.getState().exchangeSports.dreamWSConnected) {
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      wsSecMarketSubscritions[wsEvent].unsubscribe();
      delete wsSecMarketSubscritions[wsEvent];
    }
    wsSecMarketSubscritions = {};
  }

  if (store.getState().exchangeSports.dreamWSConnected) {
    for (const wsEvent of Object.keys(wsFancyMarketSubscritions)) {
      wsFancyMarketSubscritions[wsEvent].unsubscribe();
      delete wsFancyMarketSubscritions[wsEvent];
    }
    wsFancyMarketSubscritions = {};
  }

  if (sportRadarClient != null) {
    for (const wsEvent of Object.keys(wsSpSubscriptions)) {
      wsSpSubscriptions[wsEvent].unsubscribe();
      console.log('sr unsubscribed ' + wsEvent);
      delete wsSpSubscriptions[wsEvent];
    }

    wsSpSubscriptions = {};
  }
};

export const unsubscribeWsforBinaryEvent = () => {
  if (binaryStompClient !== null && binaryStompClient.connected) {
    if (wsSecBinarySubscrition) {
      wsSecBinarySubscrition.unsubscribe();
      wsSecBinarySubscrition = undefined;
    }
  }
};

export const disconnectToWS = () => {
  if (stompClient !== null) {
    unsubscribeAllWsforEvents();
    // stompClient.disconnect(() => {
    //   console.log('[webSocket.ts] Disconnected from websocket');
    // });
  }
};

export const disconnectToBinaryWS = () => {
  if (stompClient !== null) {
    unsubscribeWsforBinaryEvent();
    binaryStompClient.disconnect(() => {
      console.log('[webSocket.ts] Disconnected from websocket');
    });
  }
};
